import { Component, Input, OnInit } from '@angular/core';
import {
  MatSlideToggle,
  MatSlideToggleChange,
} from '@angular/material/slide-toggle';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { CustomSnackbarService } from '../../components/custom-snackbar/custom-snackbar-service';
import { AuthService } from '../../..//data/services/auth.service';
import { UserActivationDto } from '../../..//data/models/dto/user-activation.dto';
import { confirmationBottomSheet } from '../../..//data/utils/bottom-sheet-confirmation.utils';
import { UsersService } from '../../../data/services/user.service';

@Component({
  selector: 'app-user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.scss'],
})
export class UserCardComponent implements OnInit {
  @Input() userInfo: UserActivationDto | undefined;
  @Input() activeStatus: string = '';

  statusToggle: boolean = false;
  matToggle?: MatSlideToggle;

  constructor(
    private readonly bottomSheet: MatBottomSheet,
    private readonly snackbar: CustomSnackbarService,
    private readonly authService: AuthService,
    private readonly userService: UsersService
  ) {}

  ngOnInit(): void {
    let result = this.isChecked(this.statusToggle);
    if (result) {
      this.activeStatus = 'Acesso Habilitado';
    } else {
      this.activeStatus = 'Acesso Desabilitado';
    }
  }

  isChecked(statusToggle: boolean) {
    if (!this.userInfo?.active) {
      return (this.statusToggle = false);
    }
    return (this.statusToggle = true);
  }

  onClick(event: any): void {
    event.stopPropagation();
  }

  onChange(event: MatSlideToggleChange) {
    this.matToggle = event.source;
    if (this.userInfo) {
      if (event.checked == true) {
        return this.enableUser(this.userInfo.id);
      } else {
        return this.disableUser(this.userInfo.id);
      }
    }
    return false;
  }

  changeToggleStatus() {
    if (this.matToggle) {
      if (this.matToggle.checked) {
        this.matToggle.checked = false;
        this.activeStatus = 'Acesso Desabilitado';
      } else {
        this.matToggle.checked = true;
        this.activeStatus = 'Acesso Habilitado';
      }
    }
  }

  async enableUser(id: string): Promise<void> {
    const confirm = await confirmationBottomSheet(
      this.bottomSheet,
      'Você tem certeza que deseja habilitar o acesso deste usuário?',
      'Cancelar',
      'Habilitar',
      'custom-bottom-sheet-container'
    );
    if (confirm) {
      this.userService
        .enable(id)
        .toPromise()
        .then(() => {
          this.snackbar
            .showNotification('O usuário teve seu acesso habilitado', 2000, [
              'blue-agenda-snackbar',
            ])
            .afterDismissed()
            .toPromise();
          this.activeStatus = 'Acesso Habilitado';
        });
    } else {
      this.changeToggleStatus();
    }
  }

  async disableUser(id: string): Promise<void> {
    const confirm = await confirmationBottomSheet(
      this.bottomSheet,
      'Você tem certeza que deseja desabilitar o acesso deste usuário?',
      'Cancelar',
      'Desabilitar',
      'custom-bottom-sheet-container'
    );
    if (confirm) {
      this.userService
        .disable(id)
        .toPromise()
        .then(() => {
          this.snackbar
            .showNotification('O usuário teve seu acesso desabilitado', 2000, [
              'blue-agenda-snackbar',
            ])
            .afterDismissed()
            .toPromise();
          this.activeStatus = 'Acesso Desabilitado';
        });
    } else {
      this.changeToggleStatus();
    }
  }
}
